// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const SignalBoosterPlug = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    /*eslint-disable max-len */
    return (
        <G {...gProps}>
            <Path d="M15,5 C13.3431458,5 12,6.34314575 12,8 L12,27 C12,31.418278 15.581722,35 20,35 C24.418278,35 28,31.418278 28,27 L28,8 C28,6.34314575 26.6568542,5 25,5 L15,5 Z M15,4 L25,4 C27.209139,4 29,5.790861 29,8 L29,27 C29,31.9705627 24.9705627,36 20,36 C15.0294373,36 11,31.9705627 11,27 L11,8 C11,5.790861 12.790861,4 15,4 Z M22.5,19 C22.2238576,19 22,19.2238576 22,19.5 C22,19.7761424 22.2238576,20 22.5,20 L25.5,20 C25.7761424,20 26,19.7761424 26,19.5 C26,19.2238576 25.7761424,19 25.5,19 L22.5,19 Z M14.5,19 C14.2238576,19 14,19.2238576 14,19.5 C14,19.7761424 14.2238576,20 14.5,20 L17.5,20 C17.7761424,20 18,19.7761424 18,19.5 C18,19.2238576 17.7761424,19 17.5,19 L14.5,19 Z M20,12 C19.724,12 19.5,12.224 19.5,12.5 L19.5,15.5 C19.5,15.776 19.724,16 20,16 C20.276,16 20.5,15.776 20.5,15.5 L20.5,12.5 C20.5,12.224 20.276,12 20,12 Z" />
        </G>
    );
    /*eslint-enable max-len */
};

export default SignalBoosterPlug;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/devices/signal-booster-plug/index.js